import {IoTClient} from "./iotCoreClient";

export class ConnectionPool {
	constructor(iotWebSocket) {
		this.clientIndex = 0;
		this.clients = [];
		this.iotWebSocket = iotWebSocket;
	}

	createNewClient() {
		this.clientIndex++;

		const client = new IoTClient(this.iotWebSocket, this);
		this.push(client);

		client.connect();
		return client;
	}

	getClient() {
		if (this.clients.length) {
			const clientWithMinSubscriptions = this.clients[0];
			if (clientWithMinSubscriptions.getSubscriptionsLength === 50) {
				return this.createNewClient();
			}
			else {
				return clientWithMinSubscriptions;
			}
		}
		else {
			return this.createNewClient();
		}
	}

	push(client) {
		this.clients.push(client);
		this.bubbleUp();
	}

	bubbleUp() {
		let idx = this.clients.length - 1;
		let client = this.clients[idx];
		while (idx > 0) {
			let parentIdx = Math.floor((idx - 1) / 2);
			let parent = this.clients[parentIdx];
			if (client.getSubscriptionsLength > parent.getSubscriptionsLength) {
				break;
			}
			this.clients[parentIdx] = client;
			this.clients[idx] = parent;
			idx = parentIdx;
		}
	}

	publish(topic, data) {
		try {
			const client = this.getClient();
			client.publish(topic, data);
		} catch (ex) {
			console.log(`Error in publish of ConnectionPool: ${ex}`);
		}
	}

	addSubscription(topic) {
		try {
			const client = this.getClient();
			client.subscribe(topic);
			this.bubbleUp();
		} catch (ex) {
			console.log(`Error in addSubscription of ConnectionPool: ${ex}`);
		}
	}

	removeSubscription(topic) {
		let clientsWithTopic = []; //may be array of objects with topic and number of times subscribed in each connection?
		try {
			for (let client of this.clients) {
				if (client.getSubscriptions.includes(topic)) {
					clientsWithTopic.push(client);
				}
			}
			if (clientsWithTopic.length === 1) {
				clientsWithTopic[0].unsubscribe(topic);
				if (clientsWithTopic[0].getSubscriptionsLength == 0) {
					//disconnect client
					clientsWithTopic[0].disconnect();
					//delete the client
					const clientIndex = this.clients.findIndex(
						(c) => c.getClientId === clientsWithTopic[0].getClientId
					);
					this.clients.splice(clientIndex, 1);
					return;
				}
			}
			else {
				clientsWithTopic.shift(); //do not remove from memory for the first client
				clientsWithTopic.forEach((clientWithTopic) => {
					clientWithTopic.removeTopicSubscriptionFromMemory(topic);
				});
			}
			this.bubbleUp();
		} catch (ex) {
			console.log(`Error in removeSubscription: ${ex}`);
		}
	}

	unsubscribeAll() {
		try {
			if (this.clients && this.clients.length > 0) {
				for (let client of this.clients.slice(0)) {
					client.unsubscribeAll();
					if (client.getSubscriptionsLength === 0) {
						//disconnect client
						client.disconnect();
						//delete the client
						const clientIndex = this.clients.findIndex(c => c.getClientId === client.getClientId);
						this.clients.splice(clientIndex, 1);
					}
				}
			}
		} catch (ex) {
			console.log(`Error in removeSubscription: ${ex}`);
		}
	}

	closeAll() {
		for (let client of this.clients) {
			client.disconnect();
		}

		this.clients = [];
	}

	reconnectClients() {
		for (let client of this.clients) {
			client.disconnect();
			client.connect();
		}
	}
}